module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-event/gatsby-browser.js'),
      options: {"plugins":[],"exhibitorSort":{"fields":["name"],"order":["ASC"]},"producerSort":{"fields":["name"],"order":["ASC"]},"homePath":"/wines","exhibitorBase":"wines","baseUrl":"https://oldvineproject.netlify.app/","showRegionFilter":true,"eventId":"5dc55ed8453a230da914832b"},
    }]
